@if (visible) {
  <mat-icon class="language-link" [matMenuTriggerFor]="langMenu"
            [matTooltip]="switchLanguageLabel">language
  </mat-icon>
  <mat-menu #langMenu="matMenu">
    @for (lang of availableLanguages; track lang.code) {
      <button mat-menu-item [class.active-lang]="lang.code === currentLocale"
              (click)="switchLanguage(lang.code)">
        <span>{{ lang.nativeName }}</span>
      </button>
    }
  </mat-menu>
}
